export default "__VITE_ASSET__998fc3be__"